import type { DeepWriteable } from '@jane/shared-ecomm/types';
/* eslint-disable-next-line no-restricted-imports */
import type { TipSetting } from '@jane/shared/models';

interface UseTipSettingsParams {
  deliveryTipSettings?: DeepWriteable<TipSetting>;
  pickupMode?: 'pickup' | 'curbside' | null;
  reservationMode: string;
  selectedPaymentMethod?: any | null;
  tipPaymentMethods?: any[];
  tipSettings?: DeepWriteable<TipSetting>[];
}

export const useTipSettings = ({
  reservationMode,
  deliveryTipSettings,
  pickupMode,
  tipSettings,
  selectedPaymentMethod,
  tipPaymentMethods = [],
}: UseTipSettingsParams) => {
  const effectiveMode =
    reservationMode === 'pickup' && pickupMode === 'curbside'
      ? 'curbside'
      : reservationMode;

  const activeTipSettings =
    effectiveMode === 'delivery'
      ? deliveryTipSettings
      : tipSettings?.find(
          ({ enabled_for }: TipSetting) => enabled_for === effectiveMode
        );

  const tipAmounts =
    activeTipSettings?.custom_amounts.sort((a: number, b: number) => a - b) ||
    [];

  const isPercentage = activeTipSettings?.variant === 'percentage';

  const storeTipOptions = tipAmounts.map((value: number) => ({
    label: isPercentage ? `${value}%` : `$${value}`,
    value: isPercentage ? Number(value) * 0.01 : Number(value),
  }));

  const tipOptions = storeTipOptions.length
    ? [...storeTipOptions, { label: 'Custom', value: 'custom' }]
    : [];

  const showTip =
    !!activeTipSettings &&
    !!selectedPaymentMethod &&
    tipPaymentMethods.includes(selectedPaymentMethod);

  return {
    showTip,
    tipOptions,
    tipSettings: activeTipSettings,
  };
};
